import React from 'react';

export default function NumberCell(props) {
    return (
        <td>
            <input type="number" {...props} />
        </td>
    )
}